// extracted by mini-css-extract-plugin
module.exports = {"slider__image":"style_slider__image__2fhN0","slider___indicators":"style_slider___indicators__2iEpd","slider__icons":"style_slider__icons__1KMOD"};